import {UserSignInType} from '../../backend/enums/user-sign-in-type';
import {translations} from '../../i18n/translations';

/**
 * Array with the available user sign in types in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(userSignInTypes[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const userSignInTypes: Array<{translation: string; type: UserSignInType}> = [
  {translation: translations.user_sign_in_types[UserSignInType.Card], type: UserSignInType.Card},
  {translation: translations.user_sign_in_types[UserSignInType.Quick], type: UserSignInType.Quick},
];
